var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14286 35.7143C7.14286 33.7388 5.54688 32.1429 3.57143 32.1429C1.59598 32.1429 0 33.7388 0 35.7143V46.4286C0 48.404 1.59598 50 3.57143 50H14.2857C16.2612 50 17.8571 48.404 17.8571 46.4286C17.8571 44.4531 16.2612 42.8571 14.2857 42.8571H7.14286V35.7143ZM35.7143 0C33.7388 0 32.1429 1.59598 32.1429 3.57143C32.1429 5.54688 33.7388 7.14286 35.7143 7.14286H42.8571V14.2857C42.8571 16.2612 44.4531 17.8571 46.4286 17.8571C48.404 17.8571 50 16.2612 50 14.2857V3.57143C50 1.59598 48.404 0 46.4286 0H35.7143Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormat);
export default __webpack_public_path__ + "static/media/format.ce5e49bcb8884b3afc5c811d7172d3fe.svg";
export { ForwardRef as ReactComponent };